/*
 * Whether a failure was already put in front of the person, for the app-wide
 * fallback for mutation errors (api/queryClient.ts): a toast in a problem's
 * tone since it failed, or its words on the page (a FormError, a field's
 * message, a line under a button). Only a failure nobody said gets a toast.
 */

let lastProblemToast = 0;

/** A toast in the critical tone went up (ui/Toast). */
export function noteProblemToast() {
  lastProblemToast = Date.now();
}

/** Said already: a problem toast since `since`, or the message somewhere on the page. */
export function errorWasShown(message: string, since: number): boolean {
  if (lastProblemToast >= since) return true;
  return !!message && (document.body.textContent ?? "").includes(message);
}
